import { MarketingContentCreateInput, OfferFragment } from '@occc/graphql';

export class MarketingContentDuplicationService {
  public copy(
    marketingContents: OfferFragment['marketingContents'],
    offerId: string,
  ): MarketingContentCreateInput | null {
    const marketingContent = marketingContents?.[0];
    if (!marketingContent) {
      return null;
    }

    const {
      disclaimer,
      disclaimerUrl,
      imageUrl,
      locale,
      longDescription,
      shortDescription,
      terms,
      termsUrl,
      title,
      triggeredMessageContent: { fulfillmentSms, visibilitySms, progressSms },
      externalUrl,
      surgeonGeneralsWarning,
      customData,
      receiptContent,
    } = marketingContent;

    const marketingContentInput = {
      disclaimer,
      disclaimerUrl,
      imageUrl,
      locale,
      longDescription,
      offerId,
      shortDescription,
      terms,
      termsUrl,
      title,
      triggeredMessageContent: {
        fulfillmentSms,
        visibilitySms,
        progressSms,
      },
      externalUrl,
      surgeonGeneralsWarning,
      customData,
      receiptContent: receiptContent
        ? {
            shortDescription: receiptContent.shortDescription,
            longDescription: receiptContent.longDescription,
          }
        : receiptContent,
    };

    // The next section is used to ensure that every field in OfferCreateInput is handled
    // in the offerCreateInput object. If not, TypeScript will raise a compile-time error.
    type HandledMarketingContentCreateKeys = keyof typeof marketingContentInput;
    type AllMarketingContentCreateKeys = keyof MarketingContentCreateInput;
    type UnhandledMarketingContentCreateKeys = Exclude<
      AllMarketingContentCreateKeys,
      HandledMarketingContentCreateKeys
    >;

    // If a new key is added to MarketingContentCreateInput and not handled in the code, TypeScript will flag it as an error.
    // You can try to remove fields from the marketingContentInput object to see the error.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const checkMissingMarketingContentCreateFields: {
      [key in UnhandledMarketingContentCreateKeys]: never;
    } = {};

    return marketingContentInput;
  }
}

export const marketingContentDuplicationService = new MarketingContentDuplicationService();
